import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import { Progress, message, Tag } from "antd"
import { get } from "lodash"
import axios from "axios"
import ellipseIcon from "../../images/ellipse.svg"
import roundPencilSvg from "../../images/round-pencil.svg"
import roundDeleteSvg from "../../images/round-delete.svg"
import { LOCAL_TOKEN, LOCAL_USER_ID } from "../../utils/storage"
import { buttonAction_btns, buttonAction_context, buttonAction_s } from "../Snowplow/config2"
import moment from "moment"

/* function setColor(num) {
  let setColor = '';

  if (0 < num && num < 20) {
    setColor = '#E37879'
  } else if (20 < num && num < 40) {
    setColor = '#F6B673'
  } else if (40 <= num && num < 60) {
    setColor = '#F6D884'
  } else if (60 <= num && num < 80) {
    setColor = '#BDD898'
  } else if (80 <= num && num <= 100) {
    setColor = '#55C8AE'
  }

  return setColor;
} */

function setColorStatus(status) {
  let setColor = ""

  if (status === "borrador") {
    setColor = "#C0C0C0"
  } else if (status === "pendiente") {
    setColor = "#F6B673"
  } else if (status === "en curso" || status === "finalizada") {
    setColor = "#55C8AE"
  }

  return setColor
}
let buttonAction_btn = (tipo) => {
  let data_button = {
    category: window.location.hash
      ? window.location.hash
      : window.location.pathname,
    action: tipo,
    label: `Click a ${tipo}`,
    property: "button",
    value: LOCAL_USER_ID(),
  }
  buttonAction_s(data_button)
}
function goMetrics(id) {
  message.loading("Iniciando", 5)
  const url = `results/measure/${id}/answersbulk`
  axios
    .request({
      method: "GET",
      headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
      url: `${process.env.API_URL + url}`,
    })
    .then((e) => {
      message.success("Batch iniciado", 5)
    })
    .catch((c) => {
      const error = c
      if (error.data && error.data.code === 406) {
        message.error(
          `Hubo un error al procesar:${error.response.data.error}`,
          5
        )
      } else {
        message.error("Hubo un error al procesar:", 5)
      }
    })
}

const TagPulse = ({ text }) => {
  return (
    <>
      {text}
      <span
        style={{
          marginLeft: "8px",
          padding: "4px 8px",
          borderRadius: "3px",
          background: "rgba(55, 143, 238, 0.12)",
          color: "#378FEE",
        }}>
        Pulso
      </span>
    </>
  )
}

export const columns = (setStateFrom) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      width: 360,
      render: (text, record) => {
        return (
          <div className="measurement-history-table-cell-name">
            <span style={{ fontWeight: 600 }}>
              {record.id_measure_type == 2 ? <TagPulse text={text} /> : text}
            </span>
            <div className="measurement-history-table-cell-name-actions">
              {record.id_measure_status == 1 ? (
                <Link to={`/models/measure-create/${record.id_measure}`}>
                  <img
                    onClick={() => buttonAction_context("Editar medicion",'id_measure',record.id_measure)}
                    src={roundPencilSvg}
                  />
                </Link>
              ) : (
                <Link to={`/models/measure/${record.id_measure}`}>
                  <img
                    onClick={() => buttonAction_context("Editar medicion",'id_measure',record.id_measure)}
                    src={roundPencilSvg}
                  />
                </Link>
              )}
              {/* deleteMeasureWatcher */}
              <img
                src={roundDeleteSvg}
                onClick={() =>
                  setStateFrom("modalDeleteMeasure", true, record.id_measure)
                }
              />
            </div>
          </div>
        )
      },
    },
    {
      title: "Fecha",
      dataIndex: "date",
      sorter: (a, b) => {
        let dateA = moment(a.date_start, 'DD/MM/YYYY').format('YYYY/MM/DD')
        let dateB = moment(b.date_start, 'DD/MM/YYYY').format('YYYY/MM/DD')
        if(!a.date_start){
          return b
        }
        return dateA.localeCompare(dateB)
      },
      width: 240,
      render: (_, record) => {
        return `${record.date_start} - ${record.date_end}`
      },
    },
    {
      title: "Tasa de respuesta",
      dataIndex: "ratio",
      key: "ratio",
      sorter: (a, b) =>  parseInt(a.rate.rate) - parseInt(b.rate.rate), 
      width: 240,
      render: (text, record) => {
        const one_hundred = get(record, "rate.rate", 0) || 0

        return (
          <Progress
            format={(percent) => `${percent}%`}
            className={`measurement-history-table-progress ${
              one_hundred === 100 ? "one_hundred" : ""
            }`}
            // strokeColor={setColor(Number(text))}
            strokeColor={get(record, "rate.rate_color", "red") || "red"}
            percent={one_hundred}
            size="small"
          />
        )
      },
    },
    {
      title: "Indicador",
      dataIndex: "types",
      width: 240,
      key: "types",
      render: (text, record) => {
        return (
          <span>
            {get(record, "types")}{" "}
            {get(record, "engagement", false) && (
              <span
                style={{
                  marginLeft: "8px",
                  padding: "4px 8px",
                  borderRadius: "3px",
                  background: "rgba(44, 91, 255, 0.1)",
                  color: "#2C5BFF",
                  fontWeight: "600",
                }}>
                Engagement
              </span>
            )}
          </span>
        )
      },
    },
    {
      title: "Estado",
      dataIndex: "status",
      width: 140,
      key: "status",
      render: (text, record) => {
        let ifClose = {}

        if (text.toLowerCase() === "cerrada") {
          ifClose = {
            backgroundColor: "transparent",
            color: "#979797",
            width: "fit-content",
          }
        }

        return (
          <div
            className="measurement-history-table-status"
            style={{
              backgroundColor: setColorStatus(text.toLowerCase()),
              ...ifClose,
            }}>
            {text.toLowerCase() === "en curso" && (
              <img src={ellipseIcon} style={{ marginRight: 6 }} />
            )}
            {text}
          </div>
        )
      },
    },
    {
      title: "Detalle",
      width: 140,
      dataIndex: "detail",
      render: (_, record) => {
        if (record.status.toLowerCase() === "borrador") {
          return (
            <Fragment>
              <Link to={`/models/measure-create/${record.id_measure}`}>
                Editar &gt;
              </Link>
              {/* <span onClick={() => { goMetrics(record.id_measure) }} style={{ color: 'rgb(84, 200, 174)', display: 'block', fontSize: 12, cursor: 'pointer' }}>Answers > </span> */}
            </Fragment>
          )
        }

        return (
          <Fragment>
            <Link to={`/models/measure/${record.id_measure}`}>
              Ver más &gt;
            </Link>
            {/* <span onClick={() => { goMetrics(record.id_measure) }} style={{ color: 'rgb(84, 200, 174)', display: 'block', fontSize: 12, cursor: 'pointer' }}>~Answers > </span> */}
          </Fragment>
        )
      },
    },
  ]
}
